module.exports = __webpack_public_path__ + "img/20_111.2da492b9.png";